import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, Directive, inject, ContentChildren, NgModule } from '@angular/core';
import { IS_BROWSER, E11UtilModule } from '@engineering11/ui-lib/e11-ui-utils';

class E11DatatablePaginationComponent {
    constructor() {
        /**
         *
         *
         * @memberof UIPaginationComponent
         */
        this.currentPage = 1;
        /**
         *
         *
         * @memberof UIPaginationComponent
         */
        this.theme = 'default';
        /**
         *
         *
         * @type {PaginationSettings}
         * @memberof UIPaginationComponent
         */
        this.paginationSettings = {
            enabled: true,
            serverSide: false,
            pageLinks: 5,
            rowCount: 25,
            rowsPerPageOptions: [25, 50, 100],
        };
        /**
         *
         *
         * @memberof UIPaginationComponent
         */
        this.total = 0;
        /**
         *
         *
         * @type {number[]}
         * @memberof UIPaginationComponent
         */
        this.pages = [];
        /**
         *
         *
         * @memberof UIPaginationComponent
         */
        this.showArrows = true;
        /**
         *
         *
         * @type {EventEmitter<boolean>}
         * @memberof UIPaginationComponent
         */
        this.changePage = new EventEmitter();
        this.theme = 'default'; //Util.getTheme() as Theme
        // const observer = new MutationObserver((mutations) => {
        //   //this.theme = Util.getTheme() as Theme
        // });
        // observer.observe(Util.getElement(), {
        //   attributes: true
        // });
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        if (changes['total']) {
            // console.log(this.total,  this.paginationSettings.rowCount, 'this.total')
            this.pages = Array.from(Array(Math.ceil(this.total / this.paginationSettings.rowCount)).keys()).map((v) => v + 1);
            // console.log(this.pages, 'this.pages')
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DatatablePaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11DatatablePaginationComponent, selector: "e11-datatable-pagination", inputs: { currentPage: "currentPage", theme: "theme", paginationSettings: "paginationSettings", total: "total" }, outputs: { changePage: "changePage" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"center\">\n  <div class=\"pagination\">\n    <a href=\"javascript:void(0)\" *ngIf=\"showArrows\">&laquo;</a>\n    <a href=\"javascript:void(0)\" [ngClass]=\"{ active: page === currentPage }\" *ngFor=\"let page of pages\" (click)=\"changePage.emit(page)\">{{\n      page\n    }}</a>\n    <a href=\"javascript:void(0)\" *ngIf=\"showArrows\">&raquo;</a>\n  </div>\n</div>\n", styles: [".pagination{display:inline-block}.pagination a{color:#000;float:left;padding:8px 16px;text-decoration:none;transition:background-color .3s;border:1px solid #ddd;margin:10px 0}.center{text-align:center}.pagination a:hover:not(.active){background-color:#ddd}.pagination.skyblue a.active,.pagination.default a.active,.pagination.darkblue a.active{background-color:#00f;color:#fff;border:1px solid blue}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DatatablePaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-datatable-pagination', template: "<div class=\"center\">\n  <div class=\"pagination\">\n    <a href=\"javascript:void(0)\" *ngIf=\"showArrows\">&laquo;</a>\n    <a href=\"javascript:void(0)\" [ngClass]=\"{ active: page === currentPage }\" *ngFor=\"let page of pages\" (click)=\"changePage.emit(page)\">{{\n      page\n    }}</a>\n    <a href=\"javascript:void(0)\" *ngIf=\"showArrows\">&raquo;</a>\n  </div>\n</div>\n", styles: [".pagination{display:inline-block}.pagination a{color:#000;float:left;padding:8px 16px;text-decoration:none;transition:background-color .3s;border:1px solid #ddd;margin:10px 0}.center{text-align:center}.pagination a:hover:not(.active){background-color:#ddd}.pagination.skyblue a.active,.pagination.default a.active,.pagination.darkblue a.active{background-color:#00f;color:#fff;border:1px solid blue}\n"] }]
        }], ctorParameters: () => [], propDecorators: { currentPage: [{
                type: Input
            }], theme: [{
                type: Input
            }], paginationSettings: [{
                type: Input
            }], total: [{
                type: Input
            }], changePage: [{
                type: Output
            }] } });

class E11DatatableTemplate {
    constructor(template) {
        this.template = template;
    }
    getType() {
        return this.name;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DatatableTemplate, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: E11DatatableTemplate, selector: "[e11DatatableTemplate]", inputs: { type: "type", name: ["e11DatatableTemplate", "name"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DatatableTemplate, decorators: [{
            type: Directive,
            args: [{
                    selector: '[e11DatatableTemplate]',
                    host: {},
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { type: [{
                type: Input
            }], name: [{
                type: Input,
                args: ['e11DatatableTemplate']
            }] } });

var DataType;
(function (DataType) {
    DataType["CharField"] = "CharField";
    DataType["TextField"] = "TextField";
    DataType["IntegerField"] = "IntegerField";
    DataType["DecimalField"] = "DecimalField";
    DataType["FloatField"] = "FloatField";
    DataType["FileField"] = "FileField";
    DataType["DateTimeField"] = "DateTimeField";
    DataType["CertificateField"] = "CertificateField";
    DataType["DateField"] = "DateField";
    DataType["BooleanField"] = "BooleanField";
    DataType["TemplateField"] = "TemplateField";
})(DataType || (DataType = {}));

var ExtraTypesForGrid;
(function (ExtraTypesForGrid) {
    ExtraTypesForGrid["LogoField"] = "LogoField";
    ExtraTypesForGrid["BadgeField"] = "BadgeField";
})(ExtraTypesForGrid || (ExtraTypesForGrid = {}));
const ColumnType = { ...DataType, ...ExtraTypesForGrid };

/**
 * Filter comparison types to be used for requests in grid.
 */
var FilterComparison;
(function (FilterComparison) {
    FilterComparison["Exact"] = "exact";
    FilterComparison["Contains"] = "icontains";
    FilterComparison["StartsWith"] = "istartswith";
    FilterComparison["EndsWith"] = "iendswith";
    FilterComparison["In"] = "in";
    FilterComparison["LessThan"] = "lt";
    FilterComparison["LessThanEquals"] = "lte";
    FilterComparison["GreaterThan"] = "gt";
    FilterComparison["GreaterThanEquals"] = "gte";
    FilterComparison["IsNull"] = "isnull";
})(FilterComparison || (FilterComparison = {}));

var FilterConnector;
(function (FilterConnector) {
    FilterConnector["and"] = "and";
    FilterConnector["or"] = "or";
})(FilterConnector || (FilterConnector = {}));

var SortType;
(function (SortType) {
    SortType[SortType["Asc"] = 0] = "Asc";
    SortType[SortType["Desc"] = 1] = "Desc";
})(SortType || (SortType = {}));

class E11DataTableComponent {
    set records(data) {
        this._records = data;
        this.totalRecords = data.length;
    }
    /**
     *
     *
     * @readonly
     * @memberof E11DataTableComponent
     */
    get records() {
        return this._records;
    }
    /**
     *Creates an instance of E11DataTableComponent.
     * @param {TemplateRef<any>} templateRef
     * @memberof E11DataTableComponent
     */
    constructor() {
        /**
         *
         *
         * @type T[]
         * @memberof E11DataTableComponent
         */
        this.values = [];
        /**
         *
         *
         * @memberof E11DataTableComponent
         */
        this.totalRecords = 0;
        /**
         * Currently displayed records
         * @type `[[]]`
         * @memberof E11DataTableComponent
         */
        this._records = [];
        /**
         * Currently selected records.
         * 2-way binding
         * @type `T[]`
         * @default []
         * @example
         * [(selectedRecords)]="this.selectedRecords"
         * @memberof E11DataTableComponent
         */
        this.selectedRecords = [];
        /**
         * Currently selected records.
         * 2-way binding
         * @type `EventEmitter<any[]>`
         * @memberof E11DataTableComponent
         */
        this.selectedRecordsChange = new EventEmitter();
        /**
         * Are currently selected records the all.
         * 2-way binding
         * @type `boolean`
         * @default false
         * @example
         * [(isAllSelected)]="this.isAllSelected"
         * @memberof E11DataTableComponent
         */
        this.isAllSelected = false;
        /**
         * Are currently selected records the all.
         * 2-way binding
         * @type `EventEmitter<boolean>`
         * @memberof E11DataTableComponent
         */
        this.isAllSelectedChange = new EventEmitter();
        /**
         * TODO: Implement more column type
         * @type `any[]`
         * @memberof GridComponent
         */
        this.columns = [];
        /**
         * Shows loading indicator on request
         * @type `boolean`
         * @default false
         * @memberof GridComponent
         */
        this.loading = false;
        /**
         * Whether to show striped rows.
         */
        this.striped = false;
        /**Current page for pagination.
         * @type `number`
         * @default 1
         * @memberof GridComponent
         */
        this.currentPage = 1;
        /**
         * Reference to handle different field types.
         * @type `number`
         * @default 50
         * @memberof GridComponent
         */
        this.columnType = ColumnType;
        /**
         *
         *
         * @memberof E11DataTableComponent
         */
        this.filterOptions = {
            columnFilters: {},
            columnSorts: {},
            selections: [],
        };
        this.uiTemplates = {};
        this.bulkOperationsChecked = new EventEmitter();
        this.isBrowser = inject(IS_BROWSER);
        this.SortType = SortType;
    }
    /**
     *
     *
     * @memberof E11DataTableComponent
     */
    ngOnInit() { }
    /**
     *s
     *
     * @memberof E11DataTableComponent
     */
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            this.uiTemplates[item.getType()] = item.template;
        });
    }
    /**
     *
     *
     * @param {SimpleChanges} changes
     * @memberof E11DataTableComponent
     */
    ngOnChanges(changes) {
        if (changes['initialGridOptions'] && this.initialGridOptions) {
            this.setOptions();
        }
        if (changes['records']) {
            this.values = this.records;
            if (!this.initialGridOptions?.paginationSettings?.serverSide && this.initialGridOptions?.paginationSettings?.rowCount) {
                this.values = this.records.slice(0, this.currentPage * this.initialGridOptions?.paginationSettings?.rowCount);
            }
        }
    }
    /**
     *
     *
     * @private
     * @memberof E11DataTableComponent
     */
    setOptions() {
        this._gridOptions = { ...this.initialGridOptions };
        this.setDefaults();
        this._gridOptions.columns = this.setColumnDefaults(this._gridOptions.columns);
        this.setBulkOperationsDefaults();
    }
    /**
     *
     *
     * @private
     * @memberof E11DataTableComponent
     */
    setDefaults() {
        this._gridOptions = Object.assign({}, {
            keyField: null,
            columns: null,
            requestOptions: null,
            isLazy: true,
            rowHover: false,
            resizableColumns: true,
            scrollable: true,
            enableFilter: true,
            enableSorting: true,
            showCurrentPageReport: true,
            filterDelay: 500,
            selectable: false,
            rowHeight: 50,
            bulkOperations: [],
            enableDynamicFields: false,
            paginationSettings: {
                enabled: true,
                pageLinks: 5,
                rowCount: 25,
                rowsPerPageOptions: [25, 50, 100],
            },
        }, this._gridOptions);
    }
    setColumnDefaults(columns) {
        columns.forEach((column) => {
            if (this.initialGridOptions?.enableSorting == false) {
                column.enableSort = false;
            }
            if (column.visible === undefined) {
                column.visible = true;
            }
            if (column.enableFilter === undefined) {
                column.enableFilter = true;
            }
            if (column.enableSort === undefined) {
                column.enableSort = true;
            }
            if (column.width === undefined) {
                column.width = 250;
            }
            if (column.hasDescendants === undefined) {
                column.hasDescendants = false;
            }
            if (column.optional === undefined) {
                column.optional = true;
            }
            if (column.key instanceof Array && column.key.length > 2) {
                throw Error('Column key with descendants only support 2 steps.');
            }
        });
        return columns;
    }
    /**
     *
     *
     * @private
     * @memberof E11DataTableComponent
     */
    setBulkOperationsDefaults() {
        this._gridOptions.bulkOperations.forEach((operation) => {
            if (operation.visible === undefined) {
                operation.visible = false;
            }
        });
    }
    /**
     *
     *
     * @param {number} pageNumber
     * @memberof E11DataTableComponent
     */
    onPageChange(pageNumber) {
        this.loading = true;
        setTimeout(() => {
            this.currentPage = pageNumber;
            if (!this.initialGridOptions?.paginationSettings?.serverSide && this.initialGridOptions?.paginationSettings?.rowCount) {
                let records = this.records;
                if (Object.keys(this.filterOptions.columnFilters).length > 0) {
                    Object.keys(this.filterOptions.columnFilters).forEach((columnFilterKey) => {
                        records = records.filter((record) => (record[columnFilterKey] + '').indexOf(this.filterOptions.columnFilters[columnFilterKey].toLowerCase()) !== -1);
                    });
                }
                this.values = records.slice((this.currentPage - 1) * this.initialGridOptions?.paginationSettings?.rowCount, this.currentPage * this.initialGridOptions?.paginationSettings?.rowCount);
            }
            this.loading = false;
        }, 100);
    }
    /**
     *
     *
     * @param {string} [value='']
     * @param {''} key
     * @memberof E11DataTableComponent
     */
    onFilter(value = '', key) {
        this.currentPage = 1;
        this.filterOptions.columnFilters[key] = value;
        if (value.trim() === '') {
            this.values = this.records;
            this.totalRecords = this.records.length;
            delete this.filterOptions.columnFilters[key];
        }
        if (!this.initialGridOptions?.paginationSettings?.serverSide && this.initialGridOptions?.paginationSettings?.rowCount) {
            let records = this.records;
            if (Object.keys(this.filterOptions.columnFilters).length > 0) {
                Object.keys(this.filterOptions.columnFilters).forEach((columnFilterKey) => {
                    records = records.filter((record) => (record[columnFilterKey] + '').indexOf(this.filterOptions.columnFilters[columnFilterKey].toLowerCase()) !== -1);
                });
            }
            this.values = records.slice(0, this.currentPage * this.initialGridOptions?.paginationSettings?.rowCount);
            this.totalRecords = records.length;
        }
    }
    /**
     *
     *
     * @param {Column} column
     * @memberof E11DataTableComponent
     */
    sort(column) {
        if (!this.isBrowser)
            return;
        const isNumericColumn = [ColumnType.FloatField, ColumnType.IntegerField, ColumnType.DecimalField].includes(column.type);
        const currentSort = this.filterOptions.columnSorts[column.key];
        // Update sort state
        const newSortType = !currentSort ? SortType.Desc : currentSort.sortType === SortType.Desc ? SortType.Asc : SortType.Desc;
        this.filterOptions.columnSorts = {};
        this.filterOptions.columnSorts[column.key] = {
            field: column.key,
            sortType: newSortType,
        };
        // Sort records
        const multiplier = newSortType === SortType.Desc ? 1 : -1;
        this.records.sort((a, b) => {
            const valueA = isNumericColumn ? Number(a[column.key]) : (a[column.key] + '').toLowerCase();
            const valueB = isNumericColumn ? Number(b[column.key]) : (b[column.key] + '').toLowerCase();
            return isNumericColumn ? (valueA - valueB) * multiplier : (valueB > valueA ? 1 : -1) * multiplier;
        });
        this.currentPage = 1;
        if (!this.initialGridOptions?.paginationSettings?.serverSide && this.initialGridOptions?.paginationSettings?.rowCount) {
            this.values = this.records.slice(0, this.currentPage * this.initialGridOptions.paginationSettings.rowCount);
        }
    }
    /**
     *
     *
     * @param {} rowValue
     * @memberof E11DataTableComponent
     */
    passBulkOps(rowValue) {
        this.bulkOperationsChecked.emit(rowValue);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DataTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11DataTableComponent, selector: "e11-datatable", inputs: { initialGridOptions: "initialGridOptions", records: "records", selectedRecords: "selectedRecords", isAllSelected: "isAllSelected", loading: "loading", striped: "striped" }, outputs: { selectedRecordsChange: "selectedRecordsChange", isAllSelectedChange: "isAllSelectedChange", bulkOperationsChecked: "bulkOperationsChecked" }, providers: [], queries: [{ propertyName: "templates", predicate: E11DatatableTemplate }], usesOnChanges: true, ngImport: i0, template: "<div>\n  <div>\n    <table>\n      <thead>\n        <tr>\n          <ng-container *ngIf=\"_gridOptions.bulkOperations.length > 0\">\n            <th>\n              <input type=\"checkbox\" />\n            </th>\n          </ng-container>\n\n          <ng-container *ngFor=\"let column of _gridOptions.columns\">\n            <th class=\"tableHeader\" *ngIf=\"column.visible\">\n              <div class=\"e11-flex e11-items-center\">\n                {{ column.title }}\n                <span class=\"material-icons e11-cursor-pointer\" *ngIf=\"column.enableSort\" (click)=\"sort(column)\">{{\n                  !filterOptions.columnSorts[column.key]\n                    ? 'sort'\n                    : filterOptions.columnSorts[column.key].sortType === SortType.Desc\n                    ? 'arrow_downward'\n                    : 'arrow_upward'\n                }}</span>\n              </div>\n            </th>\n          </ng-container>\n        </tr>\n        <tr *ngIf=\"_gridOptions && _gridOptions.enableFilter\">\n          <ng-container *ngIf=\"_gridOptions.bulkOperations.length > 0\">\n            <th></th>\n          </ng-container>\n          <ng-container *ngFor=\"let column of _gridOptions.columns\">\n            <th *ngIf=\"column.visible\">\n              <div class=\"iconInside\">\n                <span class=\"material-icons\">search</span>\n                <input\n                  style=\"width: 100%\"\n                  [disabled]=\"!column.enableFilter\"\n                  (input)=\"onFilter($any($event.target).value, column.key)\"\n                  placeholder=\"{{ column.title }}\"\n                />\n              </div>\n            </th>\n          </ng-container>\n        </tr>\n      </thead>\n      <tbody [ngClass]=\"{ '[&>*:nth-child(2n+1)]:e11-bg-skin-grey/10': striped }\">\n        <ng-container *ngIf=\"loading\">\n          <td class=\"overlay\" [colSpan]=\"_gridOptions.columns.length\">\n            <div class=\"center\" style=\"vertical-align: center\">Loading....</div>\n          </td>\n        </ng-container>\n        <ng-container *ngIf=\"values\">\n          <tr *ngFor=\"let record of values\">\n            <ng-container *ngIf=\"_gridOptions.bulkOperations.length > 0\">\n              <td>\n                <input type=\"checkbox\" name=\"bulkOps\" style=\"width: 100%\" (click)=\"passBulkOps(record)\" />\n                {{ _gridOptions.bulkOperations.title }}\n              </td>\n            </ng-container>\n            <ng-container *ngFor=\"let column of _gridOptions.columns\">\n              <td *ngIf=\"column.visible\" (click)=\"column.onClick && column.onClick(record)\">\n                <ng-container *ngIf=\"column.type === columnType.TemplateField; else showValue\">\n                  <ng-container *ngTemplateOutlet=\"uiTemplates[column.key]; context: { $implicit: record }\"></ng-container>\n                </ng-container>\n                <ng-template #showValue> {{ $any(record)[column.key] }} </ng-template>\n              </td>\n            </ng-container>\n          </tr>\n          <tr *ngIf=\"values.length === 0\">\n            <td [colSpan]=\"_gridOptions.columns.length\">No data available</td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </div>\n\n  <e11-datatable-pagination\n    *ngIf=\"_gridOptions.paginationSettings.enabled\"\n    [paginationSettings]=\"_gridOptions.paginationSettings\"\n    [currentPage]=\"currentPage\"\n    [total]=\"totalRecords\"\n    (changePage)=\"onPageChange($event)\"\n  ></e11-datatable-pagination>\n</div>\n", styles: ["table{width:100%;border-collapse:collapse;position:relative}th{background:#fff;color:#000;font-weight:700}td,th{padding:10px 6px;border-bottom:1px solid #ccc;text-align:left}.overlay{position:absolute;top:0;width:100%;height:100%;background-color:#c8c8c880}.center{text-align:center}.iconInside{position:relative;display:flex;align-items:center;padding-right:8px}.iconInside span{position:absolute;right:16px;padding:0}.iconInside input{height:32px;border-radius:4px;border-color:gray;padding:0 8px}.tableHeader{align-items:center}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: E11DatatablePaginationComponent, selector: "e11-datatable-pagination", inputs: ["currentPage", "theme", "paginationSettings", "total"], outputs: ["changePage"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-datatable', providers: [], template: "<div>\n  <div>\n    <table>\n      <thead>\n        <tr>\n          <ng-container *ngIf=\"_gridOptions.bulkOperations.length > 0\">\n            <th>\n              <input type=\"checkbox\" />\n            </th>\n          </ng-container>\n\n          <ng-container *ngFor=\"let column of _gridOptions.columns\">\n            <th class=\"tableHeader\" *ngIf=\"column.visible\">\n              <div class=\"e11-flex e11-items-center\">\n                {{ column.title }}\n                <span class=\"material-icons e11-cursor-pointer\" *ngIf=\"column.enableSort\" (click)=\"sort(column)\">{{\n                  !filterOptions.columnSorts[column.key]\n                    ? 'sort'\n                    : filterOptions.columnSorts[column.key].sortType === SortType.Desc\n                    ? 'arrow_downward'\n                    : 'arrow_upward'\n                }}</span>\n              </div>\n            </th>\n          </ng-container>\n        </tr>\n        <tr *ngIf=\"_gridOptions && _gridOptions.enableFilter\">\n          <ng-container *ngIf=\"_gridOptions.bulkOperations.length > 0\">\n            <th></th>\n          </ng-container>\n          <ng-container *ngFor=\"let column of _gridOptions.columns\">\n            <th *ngIf=\"column.visible\">\n              <div class=\"iconInside\">\n                <span class=\"material-icons\">search</span>\n                <input\n                  style=\"width: 100%\"\n                  [disabled]=\"!column.enableFilter\"\n                  (input)=\"onFilter($any($event.target).value, column.key)\"\n                  placeholder=\"{{ column.title }}\"\n                />\n              </div>\n            </th>\n          </ng-container>\n        </tr>\n      </thead>\n      <tbody [ngClass]=\"{ '[&>*:nth-child(2n+1)]:e11-bg-skin-grey/10': striped }\">\n        <ng-container *ngIf=\"loading\">\n          <td class=\"overlay\" [colSpan]=\"_gridOptions.columns.length\">\n            <div class=\"center\" style=\"vertical-align: center\">Loading....</div>\n          </td>\n        </ng-container>\n        <ng-container *ngIf=\"values\">\n          <tr *ngFor=\"let record of values\">\n            <ng-container *ngIf=\"_gridOptions.bulkOperations.length > 0\">\n              <td>\n                <input type=\"checkbox\" name=\"bulkOps\" style=\"width: 100%\" (click)=\"passBulkOps(record)\" />\n                {{ _gridOptions.bulkOperations.title }}\n              </td>\n            </ng-container>\n            <ng-container *ngFor=\"let column of _gridOptions.columns\">\n              <td *ngIf=\"column.visible\" (click)=\"column.onClick && column.onClick(record)\">\n                <ng-container *ngIf=\"column.type === columnType.TemplateField; else showValue\">\n                  <ng-container *ngTemplateOutlet=\"uiTemplates[column.key]; context: { $implicit: record }\"></ng-container>\n                </ng-container>\n                <ng-template #showValue> {{ $any(record)[column.key] }} </ng-template>\n              </td>\n            </ng-container>\n          </tr>\n          <tr *ngIf=\"values.length === 0\">\n            <td [colSpan]=\"_gridOptions.columns.length\">No data available</td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </div>\n\n  <e11-datatable-pagination\n    *ngIf=\"_gridOptions.paginationSettings.enabled\"\n    [paginationSettings]=\"_gridOptions.paginationSettings\"\n    [currentPage]=\"currentPage\"\n    [total]=\"totalRecords\"\n    (changePage)=\"onPageChange($event)\"\n  ></e11-datatable-pagination>\n</div>\n", styles: ["table{width:100%;border-collapse:collapse;position:relative}th{background:#fff;color:#000;font-weight:700}td,th{padding:10px 6px;border-bottom:1px solid #ccc;text-align:left}.overlay{position:absolute;top:0;width:100%;height:100%;background-color:#c8c8c880}.center{text-align:center}.iconInside{position:relative;display:flex;align-items:center;padding-right:8px}.iconInside span{position:absolute;right:16px;padding:0}.iconInside input{height:32px;border-radius:4px;border-color:gray;padding:0 8px}.tableHeader{align-items:center}\n"] }]
        }], ctorParameters: () => [], propDecorators: { initialGridOptions: [{
                type: Input
            }], records: [{
                type: Input
            }], selectedRecords: [{
                type: Input
            }], selectedRecordsChange: [{
                type: Output
            }], isAllSelected: [{
                type: Input
            }], isAllSelectedChange: [{
                type: Output
            }], loading: [{
                type: Input
            }], striped: [{
                type: Input
            }], templates: [{
                type: ContentChildren,
                args: [E11DatatableTemplate]
            }], bulkOperationsChecked: [{
                type: Output
            }] } });

class E11DataTableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DataTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11DataTableModule, declarations: [E11DataTableComponent, E11DatatablePaginationComponent, E11DatatableTemplate], imports: [CommonModule], exports: [E11DataTableComponent, E11DatatablePaginationComponent, E11DatatableTemplate, E11UtilModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DataTableModule, imports: [CommonModule, E11UtilModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DataTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11DataTableComponent, E11DatatablePaginationComponent, E11DatatableTemplate],
                    imports: [CommonModule],
                    exports: [E11DataTableComponent, E11DatatablePaginationComponent, E11DatatableTemplate, E11UtilModule],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ColumnType, DataType, E11DataTableComponent, E11DataTableModule, E11DatatablePaginationComponent, E11DatatableTemplate, FilterComparison, FilterConnector, SortType };
